// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qU-z","hovered":"rU-z","hoverImage":"sU-z","mainImage":"tU-z","imageNoBackground":"uU-z","fullSizeImage":"vU-z"};